// extracted by mini-css-extract-plugin
export default {"focusRing":"src-signer-components-common-dig-workaround-module__focusRing--1NXOT"};